module.exports = __webpack_public_path__ + "static/media/015-cargo-2.a8de5f99.svg";